//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dilmah_map from "~/components/content-elements/dilmah-map.vue";
import BannerType1 from "~/components/content-elements/banner-type-1";
import SocialShareBtns from "~/components/social-share-btns";
import ProductPresentationHead from "~/components/loading-placeholders/product-presentation-head-pl.vue";
export default {
  components: {
    dilmah_map,
    BannerType1,
    SocialShareBtns,
    ProductPresentationHead,
  },
  data() {
    return {
      icon: "/images/map-pin-icon2.png",
      iconSize: [30, 30],
      activeIndex: 0,
      center: {
        lat: "",
        long: "",
      },
    };
  },
  mounted() {
    this.$store.dispatch("where-to-buy/getwheretobuy");
  },
  computed: {
    pageData() {
      return this.$store.state["where-to-buy"].whereTobuy;
    },
    locations() {
      let tempArray = [];
      if (this.pageData != null && this.countryFlag != null) {
        this.pageData.map_location.forEach((item) => {
          let currentCountryData =
            item.country_selection != "Global"
              ? this.countryFlag.find((country) => {
                  return country.label == item.country_selection;
                })
              : {
                  flag: "imeges/Image 373.png",
                  label: "Sri Lanka",
                  value: "LK",
                };

          tempArray.push(Object.assign(item, currentCountryData));
        });
        return tempArray;
      } else {
        return null;
      }
    },
    countryFlag() {
      if (this.$store.state.languagesAndCountries != null) {
        return this.$store.state.languagesAndCountries.countries;
      } else {
        return null;
      }
    },
  },
  watch: {
    pageData(val) {
      this.center = {
        lat: val.map_location[0].latitude,
        long: val.map_location[0].longitude,
      };
    },
  },
};
